import {create} from 'zustand';
import Axios from '../config/axios-v1-config';
import getNextWeeks from '../utils/weeks';
import {getDeliveryUsers} from "../api/user"
import {getActiveClientsApi } from "../api/company"
import {getRoutesApi, getRoutesWithDetails} from "../api/routes"
import { apiBodyMessage } from "../utils/apiErrorMessage"

// El back trata `endDate` como EXCLUSIVO a las 00:00, por lo que los retiros con
// fecha == endDate quedan fuera. Para incluir el día endDate COMPLETO mandamos el
// día siguiente. UTC-safe para no desfasar por zona horaria local.
function nextDayYMD(ymd) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd || '')) return ymd;
  const [y, m, d] = ymd.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + 1);
  return dt.toISOString().slice(0, 10);
}

export default create((set) => ({

    
    clients: [],
    selectedClients: [],
    weeks: getNextWeeks(),
    selectedWeek: 0,
    routes: [],
    clientQuery: "",
    selectedRoutes: [],
    deliveries: [],
    pickups: [],
    fetchDeliveries: async(status, userDeliveryRole, logisticCompanyId) => {
        try {
            const res = await getDeliveryUsers(status, userDeliveryRole, logisticCompanyId)
            // La respuesta de users/status/user puede venir como { docs },
            // { data: { docs } } o un array directo (y { error } ante fallo).
            // Normalizamos igual que reasignModal/FleetMap/UsersModule para que
            // el dropdown de conductores nunca quede vacío por el envoltorio.
            const deliveries = res?.docs || res?.data?.docs || (Array.isArray(res) ? res : [])
            set((state) => ({...state, deliveries}))
        } catch (error) {
            console.log(error)
            set((state) => ({...state, deliveries: []}))
        }
    },
    setClientQuery: (query) => {
        set((state) => ({...state, clientQuery: query}))
    },
    fetchRoutes: async() => {
        try {
            let routes = await getRoutesApi()
            routes = routes.data.data
            set((state) => ({...state, routes}))
        } catch (error) {
            console.log(error)
        }
    },
    fetchRoutesBeartrack: async() => {
        try {
            let routes = await getRoutesWithDetails()
            routes = routes.data
            set((state) => ({...state, routes}))
        } catch (error) {
            console.log(error)
        }
    },
    fetchClients: async(logisticCompanyId) => {
        try {
            const res = await getActiveClientsApi(logisticCompanyId)
            // La API puede devolver un array, un envoltorio { data|docs: [] } o
            // { error } ante un fallo. Normalizamos SIEMPRE a array para que los
            // consumidores (p. ej. ProgramarRecoleccionModal) puedan iterar sin
            // romper ("clients is not iterable").
            const activeClients = Array.isArray(res)
                ? res
                : Array.isArray(res?.data)
                ? res.data
                : Array.isArray(res?.docs)
                ? res.docs
                : []
            set((state) => ({...state, clients: activeClients }))
        } catch (error) {
            console.log(error)
            set((state) => ({...state, clients: [] }))
        }

    },
    toggleClient: (id, isChecked) =>{
        set((state) => {
            if(isChecked){
                return {...state, selectedClients: [...state.selectedClients, id]}
            }else{
                return {...state, selectedClients: state.selectedClients.filter(clientId => clientId !== id)}
            }
        })
        
    },
    toggleRoute: (id, isChecked) =>
        set((state) => {
            if(isChecked){
                return {...state, selectedRoutes: [...state.selectedRoutes, id]}
            }else{
                return {...state, selectedRoutes: state.selectedRoutes.filter(routeId => routeId !== id)}
            }
        }),
    selectAll: () => {
        set((state) => {
            if(state.selectedClients.length === state.clients.length){
                return {...state, selectedClients: []}
            }
            return {...state, selectedClients: state.clients.map(client => client._id)}
        })
    },
    sortClientsBySelected: () => {
        set((state) => {
            const { selectedClients, clients } = state;
            const sortedClients = [...clients];
            selectedClients.forEach((idSeleccionado) => {
              const index = sortedClients.findIndex(
                (cliente) => cliente._id === idSeleccionado
              );
              if (index !== -1) {
                const clienteSeleccionado = sortedClients.splice(index, 1)[0];
                sortedClients.unshift(clienteSeleccionado);
              }
            });
            // console.log(sortedClients)
            return { clients: sortedClients };
          });
    },
    deselectAllClients: () => {
        set((state) => {
            return {...state, selectedClients: []}
        })
    },
    deselectAllRoutes: () => {
        set((state) => {
            return {...state, selectedRoutes: []}
        })
    },
    changeClientPreferedHour: async (clientId, newHour) => {
        await Axios.put("setPreferedHour", {
            id: clientId,
            preferedHour: newHour
        })
        set((state) => {
            
            return {...state, clients: state.clients.map(client => {
                if(client._id === clientId){
                    return {...client, preferedHour: newHour}
                }else{
                    return client
                }
            })}
        })
    },
    setWeek: (week) => {
        set((state) => {
            return {...state, selectedWeek: week}
        })
    },
    fetchPickupsDateRange: async (startDate, endDate, logisticCompanyId = null, client = null, driver = null) => {
        try {
          const params = new URLSearchParams();
          if (startDate) params.append("startDate", startDate);
          // back exclusivo a las 00:00: mandamos día+1 para incluir el día final
          // completo. startDate va igual (es inclusivo).
          if (endDate) params.append("endDate", nextDayYMD(endDate));

          if (logisticCompanyId && client) {
            params.append("client", client);
          }
          // Repartidor: acota DENTRO del scope del token. El backend lo aplica después
          // del filtro de tenant, así que sólo puede reducir lo que el rol ya ve; no
          // hace falta condicionarlo al logisticCompanyId como sí pasa con `client`.
          if (driver) {
            params.append("driver", driver);
          }
    
          const { data } = await Axios.get("pickups/date-range?" + params.toString());
    
          if (data.ok) {
            set((state) => ({ ...state, pickups: data.data }));
            return data;
          } else {
            console.error("Error en fetchPickupsDateRange:", data.error);
            return data;
          }
        } catch (error) {
          // Backend answers 4xx/5xx with { ok:false, error:'<text>' } and axios
          // throws. Surface the body text (null when there is none usable)
          // instead of axios' own message, which means nothing to the user.
          return {
            ok: false,
            error: apiBodyMessage(error?.response?.data) ?? null,
            status: error?.response?.status ?? null,
          };
        }
      },
  }))